document.addEventListener('DOMContentLoaded', () => {
  function initializeDoubleRange() {
    // Get all price range containers
    const priceRanges = document.querySelectorAll('price-range');
    
    priceRanges.forEach(priceRange => {
      const fromSlider = priceRange.querySelector('input[type="range"]:first-child');
      const toSlider = priceRange.querySelector('input[type="range"]:last-child');
      const fromDisplay = priceRange.querySelector('.from-slider-value');
      const toDisplay = priceRange.querySelector('.to-slider-value');

      if (!fromSlider || !toSlider || !fromDisplay || !toDisplay) return;

      function controlFromSlider(fromSlider, toSlider) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#ccc', '#000', toSlider);
        if (from > to) {
          fromSlider.value = to;
        }
        updateSliderValues();
      }

      function controlToSlider(fromSlider, toSlider) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#ccc', '#000', toSlider);
        setToggleAccessible(toSlider);

        const maxValue = parseFloat(toSlider.getAttribute('data-max'));

        if (from <= to) {
            const currentValue = parseFloat(toSlider.value);
            // If we're at the last possible integer value, use the max
            if (Math.ceil(currentValue) >= Math.floor(maxValue)) {
                toSlider.value = maxValue;
            }
        } else {
            toSlider.value = from;
        }
        updateSliderValues();
      }

      function getParsed(currentFrom, currentTo) {
        const from = parseFloat(currentFrom.value);
        const to = parseFloat(currentTo.value);
        return [from, to];
      }

      function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = parseFloat(to.max) - parseFloat(to.min);
        const fromPosition = parseFloat(from.value) - parseFloat(to.min);
        const toPosition = parseFloat(to.value) - parseFloat(to.min);
        controlSlider.style.background = `linear-gradient(
          to right,
          ${sliderColor} 0%,
          ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
          ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
          ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
          ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
          ${sliderColor} 100%)`;
      }

      function setToggleAccessible(currentTarget) {
        if (parseFloat(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }

      function updateSliderValues() {
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        
        fromDisplay.textContent = formatter.format(fromSlider.value);
        toDisplay.textContent = formatter.format(toSlider.value);
      }

      function resetSlider() {
        // Reset to initial values
        fromSlider.value = fromSlider.min;
        toSlider.value = toSlider.max;
        
        // Update the visual state
        fillSlider(fromSlider, toSlider, '#ccc', '#000', toSlider);
        setToggleAccessible(toSlider);
        updateSliderValues();
      }

      // Initialize visual state without resetting values
      fillSlider(fromSlider, toSlider, '#ccc', '#000', toSlider);
      setToggleAccessible(toSlider);
      updateSliderValues();

      // Event listeners
      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider);

      // Handle price range clearing for this specific range
      const clearButton = priceRange.closest('details').querySelector('.clear-price-range');
      if (clearButton) {
        clearButton.addEventListener('click', (event) => {
          event.preventDefault();
          resetSlider();
        });
      }
    });
  }

  // Initialize on page load
  initializeDoubleRange();

  // Re-initialize when Shopify updates the filters, but don't reset values
  document.addEventListener('shopify:section:load', () => {
    // Small delay to ensure DOM is ready
    setTimeout(initializeDoubleRange, 0);
  });
});